export default {
	data() {
		return {
			loading: true,
			list: [],
			totalCount: 0,
			query: {
				start: 1,
				size: 20,
			},
			authKey: '',
			authList: []
		}
	},
	created() {
		//this.getList()
		// let permissionsKeyObj = localStorage.getItem("permissionsKeyObj");
		// permissionsKeyObj = JSON.parse(permissionsKeyObj);
		// this.authKey = permissionsKeyObj.key
		// this.authList = permissionsKeyObj.list
	},
	methods: {
		// 重置
		reset() {
			this.query = {
				start: 1,
			}
			this.getList()
		},
		///^[1-9]\d*$/
		bigNum(num) {
			return num.replace(/[^\d]/g, '')
		},
		zeroNum(num) {
			return num.replace(/[0-9]/g, '')
    },
    isMoneyTwo (money) {
			if (!isNaN(money)) {
				return money
			} else {
				return money.substr(0, money.length - 1)
			}
    },
		isMoney(money) {
			let exp = /^([1-9][\d]{0,7}|0)(\.[\d]{0,9})?$/g
			if (exp.test(money)) {
				return money
			} else {
				return money.substr(0, money.length - 1)
			}
		},
		IsCard(str) {
			var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
			return reg.test(str)
		},
		getQueryVariable(variable) {
			var query = window.location.href
			console.log(query);
			var vars = query.split('?')
			console.log(vars);
			for (var i = 0; i < vars.length; i++) {
				var pair = vars[i].split('=')
				if (pair[0] == variable) {
					return pair[1]
				}
			}
			return false
		},
		// 查询
		doQuery() {
			this.query.start = 1
			this.getList()
		},
		// 查询
		doData() {
			this.query.start = 1
			this.totalCounts();
		},
		//分页
		doPageQuery(val) {
			if (val.start || val.size) {
				this.query = Object.assign(this.query, val)
			} else {
				this.query = Object.assign(this.query, val)
				//this.query.start = 1
			}
			this.getList()
		},
		doDataQuery(val) {
			if (val.start || val.size) {
				this.query = Object.assign(this.query, val)
			} else {
				this.query = Object.assign(this.query, val)
				//this.query.start = 1
			}
			// if (val.start > 1) { 
			//   this.query.lastRecordId = this.list[this.list.length -1].id;
			// }
			this.getData()
		},
		formatNumber(n) {
			n = n.toString()
			return n[1] ? n : '0' + n
		},
		formatDate(times) {
			if (!times) return ''
			let date = new Date(times)
			const year = date.getFullYear()
			const month = date.getMonth() + 1
			const day = date.getDate()
			const hour = date.getHours()
			const minute = date.getMinutes()
			const second = date.getSeconds()
			if (
				[year, month, day].map(this.formatNumber).join('-') +
				' ' +
				[hour, minute, second].map(this.formatNumber).join(':') ==
				'NaN-NaN-NaN NaN:NaN:NaN'
			) {
				return ''
			} else {
				return (
					[year, month, day].map(this.formatNumber).join('-') +
					' ' +
					[hour, minute, second].map(this.formatNumber).join(':')
				)
			}
		},
    formatDay (times) {
      if (!times) return
			let date = new Date(times)
			const year = date.getFullYear()
			const month = date.getMonth() + 1
			const day = date.getDate()
			if (
				[year, month, day].map(this.formatNumber).join('-') ==
				'NaN-NaN-NaN'
			) {
				return ''
			} else {
				return [year, month, day].map(this.formatNumber).join('-')
			}
			return [year, month, day].map(this.formatNumber).join('-')
		},
		formatMonth(val) {
			if (!val) {
				return ''
			}

			let now = new Date(val),
				y = now.getFullYear(),
				m = now.getMonth() + 1
			return y + '-' + (m < 10 ? '0' + m : m)
		},
		getLastMonth(arg) {
			let year, lastMonth;
			let date = arg || new Date();
			let nowYear = date.getFullYear(); //当前年：四位数字
			let nowMonth = date.getMonth(); //当前月：0-11
			if (nowMonth == 0) { //如果是0，则说明是1月份，上一个月就是去年的12月
				year = nowYear - 1;
				lastMonth = 12;
			} else { //不是1月份，年份为当前年，月份本来是要减1的，但是由于`getMonth()`的月份本身就是少了1的，所以月份不用变。
				year = nowYear;
				lastMonth = nowMonth;
			}
			lastMonth = lastMonth < 10 ? ('0' + lastMonth) : lastMonth; //月份格式化：月份小于10则追加个0
			let lastYearMonth = year + '-' + lastMonth;
			return lastYearMonth;
		},
		// 获取指定月份的 月初和月末
		getStartDay(val) {
			var now = new Date(val); //当前日期
			var nowMonth = now.getMonth(); //当前月
			var nowYear = now.getFullYear(); //当前年
			//本月的开始时间
			var monthStartDate = this.getDate(new Date(nowYear, nowMonth, 1));
			//本月的结束时间
			var monthEndDate = this.getDate(new Date(nowYear, nowMonth + 1, 0));
			return { monthStartDate, monthEndDate }
		},
		getCurrentDate() {
			return this.formatDay(new Date());
		},
		getDate(val) {
			if (!val) {
				return ''
			}
			let now = new Date(val),
				y = now.getFullYear(),
				m = now.getMonth() + 1,
				d = now.getDate();
			return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d);
		},
		formatMonthChian(val) {
			if (!val) {
				return ''
			}

			let now = new Date(val),
				y = now.getFullYear(),
				m = now.getMonth() + 1
			return y + '年' + (m < 10 ? '0' + m : m) + '月'
		},
		datedifference(sDate1, sDate2) {
			// 计算两个时间的天数   sDate1和sDate2是2006-12-18格式
			var dateSpan, tempDate, iDays
			sDate1 = Date.parse(sDate1)
			sDate2 = Date.parse(sDate2)
			dateSpan = sDate2 - sDate1
			dateSpan = Math.abs(dateSpan)
			iDays = Math.floor(dateSpan / (24 * 3600 * 1000))
			return iDays
		},
		//初始化列表
		getList() {
			this.loading = true
			if (this.url) {
				this.$api.post(this.url, this.query).then((res) => {
					if (res) {
						this.list = res.list
						this.loading = false
						this.totalCount = Number(res.totalCount)
					}
				})
			}
		},
		//初始化列表
		getData() {
			this.loading = true;
			if (this.url) {
				this.list = [];
				this.$api.post(this.url, this.query).then((res) => {
					if (res) {
						this.list = res;
						this.loading = false;
					}
				})
			}
		},
		ossMerchatDelImg(obj) {
			this.$api.post(this.$url.merchatOss.deleteImg, obj).then(ret => { })
		},
		// 判断是否有列表权限
		checkAuthList(auth) {
			let permissionsKeyObj = localStorage.getItem("permissionsKeyObj");
			permissionsKeyObj = JSON.parse(permissionsKeyObj);
			let authList = permissionsKeyObj.list
			console.log(authList);
			if (authList.includes(auth)) {
				return true
			} else {
				return false
			}
    },
     /**
     * 根据身份证号码计算年龄并判断是否大于50岁
     * @param {string} idCard - 身份证号码（支持15位和18位）
     * @param {Date} [referenceDate] - 参考日期，默认为当前日期
     * @returns {Object} 返回包含判断结果和详细信息的对象
     */
    isIdCardAgeOver50(idCard, referenceDate = new Date()) {
      // 从身份证号码中提取出生日期
      let birthYear, birthMonth, birthDay;
      
      if (idCard.length === 15) {
        // 15位身份证：第7-12位为生日（YYMMDD）
        // 年份处理：15位身份证年份为2位，需要判断是19xx还是20xx
        const year = parseInt(idCard.substring(6, 8), 10);
        const month = parseInt(idCard.substring(8, 10), 10) - 1; // 月份从0开始
        const day = parseInt(idCard.substring(10, 12), 10);
        
        // 判断年份是19xx还是20xx
        // 简单规则：大于等于当前年份后两位的，认为是19xx年出生（因为现在15位身份证的基本是老人）
        const currentYearLastTwo = referenceDate.getFullYear() % 100;
        birthYear = year <= currentYearLastTwo ? 1900 + year : 2000 + year;
        birthMonth = month;
        birthDay = day;
      } else {
        // 18位身份证：第7-14位为生日（YYYYMMDD）
        birthYear = parseInt(idCard.substring(6, 10), 10);
        birthMonth = parseInt(idCard.substring(10, 12), 10) - 1; // 月份从0开始
        birthDay = parseInt(idCard.substring(12, 14), 10);
      }
      
      // 创建出生日期对象
      const birthDate = new Date(birthYear, birthMonth, birthDay);
      // 计算年龄
      let age = referenceDate.getFullYear() - birthDate.getFullYear();
      
      // 如果今年还没过生日，年龄减1
      const currentMonth = referenceDate.getMonth();
      const currentDay = referenceDate.getDate();
      
      if (
        currentMonth < birthMonth || 
        (currentMonth === birthMonth && currentDay < birthDay)
      ) {
        age--;
      }
      
      // 判断是否大于等于50岁
      const isOver50 = age >= 50;
      
      // 返回详细信息
      return {
        isOver50,                    // 是否大于50岁
        age,                        // 实际年龄
        birthDate: birthDate,       // 出生日期对象
        birthDateStr: birthDate.toLocaleDateString('zh-CN'), // 格式化出生日期
        referenceDate: referenceDate, // 参考日期
        idCardType: idCard.length === 15 ? '15位' : '18位', // 身份证类型
      };
    }
	},
}
